import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledFormsTemplatesSearchInput = styled(StyledFlex)`
   margin-bottom: 16px;

   &:empty {
      display: none;
   }
`;
